import * as React from 'react'
import { connect } from 'react-redux'

import { filterChanged, trackGoogleAnalyticsEvent } from 'common/actions'
import { DepositAmountIntentRangeOptions } from 'embed/constants'

import { ButtonListOption } from 'embed/components/ButtonList'
import Modal from 'embed/components/Modal'
import { Filter, GoogleAnalyticsActions, Product } from 'even-ts-static'
const styles = require('./styles')

export interface Props {
  dispatchDepositAmountChanged: (amount: DepositAmountIntentRangeOptions) => void
  dispatchTrackGoogleAnalyticsDepositAmountFilterChanged: () => void
  onSelected: () => void
}

const DepositAmountModalView: React.FC<Props> = ({
  dispatchDepositAmountChanged,
  dispatchTrackGoogleAnalyticsDepositAmountFilterChanged,
  onSelected,
}) => {
  const onSelect = React.useCallback(
    (amount: DepositAmountIntentRangeOptions) => {
      dispatchDepositAmountChanged(amount)
      dispatchTrackGoogleAnalyticsDepositAmountFilterChanged()
      onSelected()
    },
    [dispatchDepositAmountChanged, dispatchTrackGoogleAnalyticsDepositAmountFilterChanged, onSelected],
  )

  const name = 'depositAmount'

  return (
    <Modal>
      <div className={styles.despositAmountModal}>
        <h2>How much would you like to deposit?</h2>

        <ButtonListOption
          checked={false}
          label="$1,000 or less"
          name={name}
          onClick={onSelect}
          value={DepositAmountIntentRangeOptions.LESS_THAN_1000}
        />
        <ButtonListOption
          checked={false}
          label="$1,000 - $5,000"
          name={name}
          onClick={onSelect}
          value={DepositAmountIntentRangeOptions.BETWEEN_1000_AND_5000}
        />
        <ButtonListOption
          checked={false}
          label="More than $5,000"
          name={name}
          onClick={onSelect}
          value={DepositAmountIntentRangeOptions.MORE_THAN_5000}
        />

        <p>
          There may be certain minimum deposit and/or other funding requirements as well as restrictions placed in order
          to open an account and/or to earn the stated Annual Percentage Yield. Maximum balance limits may also apply.
          Please make sure to review the details as well as any Terms and Conditions on each provider's website.
        </p>
      </div>
    </Modal>
  )
}

const mapDispatchToProps = (dispatch) => ({
  dispatchDepositAmountChanged: (amount: DepositAmountIntentRangeOptions) =>
    dispatch(filterChanged(Product.Deposits, Filter.DepositAmountIntentRange, amount, { userInitiated: true })),
  dispatchTrackGoogleAnalyticsDepositAmountFilterChanged: () =>
    dispatch(
      trackGoogleAnalyticsEvent(GoogleAnalyticsActions.Filtered, undefined, undefined, Filter.DepositAmountIntentRange),
    ),
})

export const DepositAmountModal = connect(null, mapDispatchToProps)(DepositAmountModalView)
